<template>
  <div>
    <Badge
      :status="status"
      resizable
    >
      {{ label }}
    </Badge>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Badge } from '@stakeui';

const props = defineProps({
  changeType: String,
  conflict: Boolean,
});

const LABEL_MAP = {
  'both_empty': 'Empty',
  'addition': 'Added',
  'removal': 'Removed',
  'change': 'Updated',
  'same': 'Identical',
};

const STATUS_MAP = {
  'both_empty': 'ghost',
  'addition': 'success',
  'removal': 'danger',
  'change': 'warning',
  'same': 'ghost',
};

const status = computed(() => {
  if (props.conflict) return 'danger';
  if (!props.changeType) return '';
  return STATUS_MAP[props.changeType] || '';
});

const label = computed(() => {
  if (props.conflict) return 'Conflicts';
  if (!props.changeType) return '';
  return LABEL_MAP[props.changeType] || '';
});
</script>
